<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-2
        p.mb-0 Mostrar lista de opciones. (Solo para Widget Web)
        p.text-secondary.text-sm.mb-0 Muestra una lista de opciones seleccionables. La lista debe ser un arreglo de objetos.
        fieldset(:disabled="disabled")
          b-form-group.mb-1(label="Título de lista:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'title'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Título", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="Subtítulo de lista:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'subtitle'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Subtítulo", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="Título del botón:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'button_title'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Título del botón", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="Lista a mostrar:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'list'")
            template(#description)
              .text-sm Cada objeto de la lista debe contener
                span.text-primary.ml-1 title
                span.mx-1 y
                span.text-primary payload
              ul.mb-1
                li title: Texto a mostrar en el chat
                li payload: Valor de la opción seleccionada
            vue-tribute(:options="tributeOpts")
              b-form-textarea.disabled-white(size="sm", no-resize, max-rows="100", placeholder='[{"title": "Título", "payload": "Valor"}]', :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)", @focusout="isJson($event)")
          b-form-checkbox.mb-1(switch, v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'sort'", :checked="parseBoolean(template_attribute.value)", @change="update(template_attribute, $event)") {{template_attribute.value ? 'Sí' : 'No' }} ordenar alfabéticamente
          b-form-group.mb-0(label="Guardar payload en variable:", description="Si no se especifica una variable se guardará en el valor de title", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'user_attribute_id'")
            k-select.disabled-white(placeholder="- Seleccionar variable -", :options="user_attributes", :disabled="disabled", :value="template_attribute.value || null", @input="update(template_attribute, $event)")
      template-connector(v-for="connector in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import templateCommon from '../../helpers/template-common'
import Connector from './connectors/Connector.vue'
import TemplateTools from './common/Tools.vue'
import _debounce from 'lodash.debounce'
import { createNamespacedHelpers } from 'vuex'
const accountController = createNamespacedHelpers('account')

export default {
  mixins: [templateCommon],
  data () {
    return {
    }
  },
  computed: {
    ...accountController.mapState({
      user_attributes: state => state.user_attributes.filter(el => el.user_attribute_id && el.name).map(a => {
        return {
          label: a.name,
          id: a.user_attribute_id
        }
      })
    }),
  },
  methods: {
    update (template_attribute, value) {
      template_attribute.value = value
      const attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value

      this.updateAttribute(this.block_id, this.template_id, attribute)

      this.$message.success('Actualizado')
    },
  },
  components: {
    'template-connector': Connector,
    TemplateTools
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId) => {
      if (collapseId === `advance_search_collapse_${this.template_id}`) {
        setTimeout(() => {
          this.repaintBlock()
        }, 500)
      }
    })
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      const newValue = value.target._value

      this.update(template_attribute, newValue)

      this.$message.success('Actualizado')
    }, 100, { leading: false, trailing: true })
  },
}
</script>

<style lang="scss" scoped>

</style>
